/**
 * Structured logger utility — Commandment IX compliance.
 *
 * Rules:
 * - Never use bare console.* in production code.
 * - Errors route through Sentry (captureError) when configured.
 * - When Sentry is not configured the SDK no-ops gracefully — no fallback console.*.
 * - logInfo / logWarn are intentionally no-ops in this app (use toast for UX feedback).
 */
import { captureError } from '../config/sentry';

/**
 * Log an error through the structured error pipeline.
 * Sends to Sentry when DSN is configured; silently discarded otherwise.
 *
 * @param {Error|string} error   - The error object or message
 * @param {Object}       context - Optional key-value context bag
 */
export const logError = (error, context = {}) => {
  const err = error instanceof Error ? error : new Error(String(error));
  captureError(err, context);
};

/**
 * No-op placeholders — kept here so imports stay consistent
 * if logging levels are added in the future.
 */
export const logWarn  = () => {};   // intentional no-op
export const logInfo  = () => {};   // intentional no-op
export const logDebug = () => {};   // intentional no-op
